import type { Localization } from '@mui/material/locale'
import {
  deDE as mui_deDE,
  enUS as mui_enUS,
  esES as mui_esES,
  frFR as mui_frFR,
  nbNO as mui_nbNO,
  svSE as mui_svSE,
  zhCN as mui_zhCN,
} from '@mui/material/locale'
import type { Locale } from 'date-fns'
import {
  de as dateFns_de,
  enUS as dateFns_enUS,
  es as dateFns_es,
  fr as dateFns_fr,
  nb as dateFns_nb,
  sv as dateFns_sv,
  zhCN as dateFns_zhCN,
} from 'date-fns/locale'

export interface LanguageInfo {
  jsonFileName: string
  localeName: string
  shortLabel: string
  label: string
  flagCode: string
  azureTranslateLanguageCode: string //See https://learn.microsoft.com/en-us/azure/ai-services/translator/language-support
  hubSpotLocale: string //The locale HubSpot embedded forms ship their own built-in strings for
  muiLocale: Localization
  dateFnsLocale: Locale
}

export const SUPPORTED_LANGUAGES: LanguageInfo[] = [
  {
    jsonFileName: 'en',
    localeName: 'en-US',
    shortLabel: 'EN',
    label: 'English',
    flagCode: 'GB',
    azureTranslateLanguageCode: 'en',
    hubSpotLocale: 'en',
    muiLocale: mui_enUS,
    dateFnsLocale: dateFns_enUS,
  },
  {
    jsonFileName: 'sv',
    localeName: 'sv-SE',
    shortLabel: 'SV',
    label: 'Svenska',
    flagCode: 'SE',
    azureTranslateLanguageCode: 'sv',
    hubSpotLocale: 'sv',
    muiLocale: mui_svSE,
    dateFnsLocale: dateFns_sv,
  },
  {
    jsonFileName: 'de',
    localeName: 'de',
    shortLabel: 'DE',
    label: 'Deutsch',
    flagCode: 'DE',
    azureTranslateLanguageCode: 'de',
    hubSpotLocale: 'de',
    muiLocale: mui_deDE,
    dateFnsLocale: dateFns_de,
  },
  {
    jsonFileName: 'es',
    localeName: 'es-ES',
    shortLabel: 'ES',
    label: 'Español',
    flagCode: 'ES',
    azureTranslateLanguageCode: 'es',
    hubSpotLocale: 'es',
    muiLocale: mui_esES,
    dateFnsLocale: dateFns_es,
  },
  {
    jsonFileName: 'zh',
    localeName: 'zh-CN',
    shortLabel: '中文',
    label: '中文 (简体)',
    flagCode: 'CN',
    azureTranslateLanguageCode: 'zh-Hans',
    hubSpotLocale: 'zh-cn',
    muiLocale: mui_zhCN,
    dateFnsLocale: dateFns_zhCN,
  },
  {
    jsonFileName: 'no',
    localeName: 'no',
    shortLabel: 'NO',
    label: 'Norsk',
    flagCode: 'NO',
    azureTranslateLanguageCode: 'nb',
    hubSpotLocale: 'no',
    muiLocale: mui_nbNO,
    dateFnsLocale: dateFns_nb,
  },
  {
    jsonFileName: 'fr',
    localeName: 'fr',
    shortLabel: 'FR',
    label: 'Français',
    flagCode: 'FR',
    azureTranslateLanguageCode: 'fr',
    hubSpotLocale: 'fr',
    muiLocale: mui_frFR,
    dateFnsLocale: dateFns_fr,
  },
].sort((a, b) => a.label.localeCompare(b.label, 'en-US'))
